import $ from "jquery";
import { debounce } from './Helpers/debounce';
import { toggleHeaderBorder } from './Helpers/headerBorderToggler';
import { SearchModule } from './SearchModule';

export class MenuModule {

    constructor() {
        this.$siteHeader = $('.site-header');
        this.$siteHeaderOverlay = $('.site-header__overlay');
        this.$submenuSet = $('.main-nav-sub-menu');
        this.$langMenu = $('.lang-nav');
        this.$mainMenu = $('.main-nav');
        this.$searchIcon = $('.menu-search-icon');
        this.$burgerButton = $('[data-burger-trigger]');
        this.$body = $('body');
        this.overlayHeight = 0;
        this.searchModule = new SearchModule();

        this.activeClasses = {
            langMenu: 'lang-nav--alternative',
            mainMenu: 'main-nav--alternative',
            searchIcon: 'menu-search-icon--alternative-color',
            overlay: 'site-header__overlay--active'
        }
    }

    setOverlayHeight() {
        let highest = 0;
        this.$submenuSet.each(function() {
            const currentHeight = $(this).outerHeight();
            if (currentHeight > highest) {
                highest = currentHeight;
            }
        });
        const siteHeaderHeight = this.$siteHeader.outerHeight();
        this.overlayHeight = parseInt(highest + siteHeaderHeight); 

        if (this.isMobileMenu()) {
            this.overlayHeight = parseInt(window.innerHeight);
        }

        this.$siteHeaderOverlay.css({ height: this.overlayHeight  + 'px' });
    }

    openSubmenu(e) {
        if (this.searchModule.searchIsOpen() || this.isMobileMenu()) {
            return;
        }
        const $li = $(e.currentTarget).parent();
        const $currentSubmenu = $li.find('.main-nav-sub-menu');
        const timeOutTime = (this.overlayIsOpen()) ? 1 : 300;
        $li.addClass('active');
        this.openOverlay();
        
        setTimeout(() => {
            this.closeAllSubmenues();
            /* check again if overlay is stil opened to prevent flcikering submenuitem if mouse passes quickly */
            if (this.overlayIsOpen()) {
                $currentSubmenu.addClass('active');
                $li.addClass('active');
            }
        }, timeOutTime);
    }

    closeAllSubmenues() {
        this.$submenuSet.each(function() {
            const $el = $(this);
            $el.closest('.menu-item-has-children').removeClass('active');
            $el.removeClass('active');
        });
    }

    overlayIsOpen() {
        return this.$siteHeaderOverlay.hasClass(this.activeClasses.overlay);
    }

    openOverlay() {
        if (this.overlayIsOpen()) {
            return;
        }
        this.$siteHeaderOverlay.addClass(this.activeClasses.overlay);
        this.addBlueColors();
        toggleHeaderBorder(true);
        this.addOverlayClosingListeners();
        this.$body.addClass('prevent-scroll');
    }

    closeOverlay(withoutDelay) {
        this.removeOverlayClosingListeners();
        this.$siteHeaderOverlay.removeClass(this.activeClasses.overlay);

        const closingFunctions = () => {
            this.closeAllSubmenues();
            this.revertBlueColors();
            toggleHeaderBorder(false);
            this.$mainMenu.removeClass('active-mobile');
            this.$burgerButton.removeClass('is-active');
            this.$body.removeClass('prevent-scroll');
        };

        if (typeof withoutDelay != 'undefined' && withoutDelay) {
            closingFunctions();
        } else {
            setTimeout(() => {
                closingFunctions();
            }, 50);
        }
    }

    addOverlayClosingListeners() {
        $("body").on('mousemove.overlay', (e) => {
            if (e.pageY > this.overlayHeight) {
                this.closeOverlay();
            }
        });
        $("body").on('keyup.overlay', (e) => {
            if (e.keyCode === 27) { /* close on escape */ 
                this.closeOverlay();
            }
            if (!$(document.activeElement).closest('.site-header').length) { /* close if focus is outside of siteheader */
                this.closeOverlay();
            }
        });
    }
    removeOverlayClosingListeners() {
        $("body").off('.overlay');
    }

    // only add colors if not already in alternative menu
    addBlueColors() {
        if (!this.$langMenu.hasClass(this.activeClasses.langMenu)) {
            this.$langMenu.addClass(this.activeClasses.langMenu).addClass('coloring-added');
        }
        if (!this.$mainMenu.hasClass(this.activeClasses.mainMenu)) {
            this.$mainMenu.addClass(this.activeClasses.mainMenu).addClass('coloring-added');
        }
        if (!this.$searchIcon.hasClass(this.activeClasses.searchIcon)) {
            this.$searchIcon.addClass(this.activeClasses.searchIcon).addClass('coloring-added');
        }
    }

    revertBlueColors() {
        $('.coloring-added')
        .removeClass(this.activeClasses.langMenu)
        .removeClass(this.activeClasses.mainMenu)
        .removeClass(this.activeClasses.searchIcon)
        .removeClass('coloring-added');
    }

    isMobileMenu() {
        return window.innerWidth <= 1024;
    }

    toggleSubmenuInMobile(e) {
        if (e.target.tagName.toLowerCase() == 'li') {
            const $li = $(e.target);
            const $currentSubmenu = $li.find('.main-nav-sub-menu');
            $li.toggleClass('active');
            $currentSubmenu.toggleClass('active');
            
        }
    }
    toggleMobileMenu() {
        if (this.$mainMenu.hasClass('active-mobile')) {
            this.$mainMenu.removeClass('active-mobile');
            this.$burgerButton.removeClass('is-active');
            this.closeOverlay();
        } else {
            this.$mainMenu.addClass('active-mobile');
            this.$burgerButton.addClass('is-active');
            this.openOverlay();
        }
    }

    init() {
        this.setOverlayHeight();
        $(window).on('resize', debounce(() => {
                this.setOverlayHeight();
            }, 100) 
        );
        $('.main-nav .menu-item-has-children > a').on('mouseenter focus', (e) => { this.openSubmenu(e); })
        $('.main-nav .menu-item-has-children').on('click', (e) => { this.toggleSubmenuInMobile(e); });
        this.$burgerButton.on('click', (e) => { this.toggleMobileMenu(e); });
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/MenuModule.js